import React from 'react';
import { useNotificationSystem } from '../context/NotificationContext';
import { useChatUI } from '../context/ChatUIContext';
import './MessageToasts.css';

// ── IN-APP MESSAGE TOASTS ────────────────────────────────────────────────────
// Sender, a one-line preview, and a click that opens the conversation.
//
// Hand-rolled rather than react-toastify or hot-toast: this shows one kind of
// thing, it is ~40 lines, and it inherits the app's own styling for free. A
// toast library would be a dependency, a bundle cost and a second theme to keep
// in step, all to render a rounded box.
//
// Mounted once, at the app root — see NotificationProvider.
export default function MessageToasts() {
  const { toasts, dismissToast } = useNotificationSystem();
  const { openMessages } = useChatUI();

  if (!toasts?.length) return null;

  return (
    <div className="mt-wrap" role="region" aria-live="polite" aria-label="New messages">
      {toasts.map(toast => (
        <button
          key={toast.id}
          type="button"
          className="mt-toast"
          onClick={() => { openMessages(toast.chatId); dismissToast(toast.id); }}
        >
          <span className="mt-avatar" aria-hidden="true">
            {toast.avatar
              ? <img src={toast.avatar} alt="" />
              : <span className="mt-initial">{(toast.from || '?').trim().charAt(0).toUpperCase()}</span>}
          </span>

          <span className="mt-body">
            <span className="mt-from">{toast.from}</span>
            <span className="mt-text">{toast.text}</span>
          </span>

          {/* A span, not a nested button — a button inside a button is invalid
              HTML and browsers resolve it unpredictably. */}
          <span
            className="mt-close"
            role="button"
            tabIndex={-1}
            aria-label="Dismiss"
            onClick={(e) => { e.stopPropagation(); dismissToast(toast.id); }}
          >
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none"
              stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </span>
        </button>
      ))}
    </div>
  );
}
